module.exports = __webpack_public_path__ + "static/media/Aniket Warhade.e48336b5.jpg";